import { Exclude, Expose } from "class-transformer";

@Exclude()
export class CreateObserverTableDto {
    @Expose()
    readonly table_name: string;

    @Expose()
    readonly insert: boolean;

    @Expose()
    readonly delete: boolean;

    @Expose()
    readonly update: boolean;
}
